import { render, staticRenderFns } from "./permission-group-transferNew.vue?vue&type=template&id=6143a944&scoped=true&"
import script from "./permission-group-transferNew.vue?vue&type=script&lang=js&"
export * from "./permission-group-transferNew.vue?vue&type=script&lang=js&"
import style0 from "./permission-group-transferNew.vue?vue&type=style&index=0&id=6143a944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143a944",
  null
  
)

export default component.exports